import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter as Router, Route, Link, Switch } from 'react-router-dom';
import LandingPage from './pages/LandingPage';

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Switch>
        <Route exact path="/landing" component={LandingPage} />
        <Route component={App} />
        <App />
      </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);


